module.exports = __webpack_public_path__ + "media/evolve/assets/icons/static/disable-255311691e6df0cc040aad2fe7ca0b7a.svg";